import React from 'react';

export function Table({ children }: { children: JSX.Element[] }) {
  return (
    <div className="w-full flex flex-col grow custom-scrollbar">
      <div className="w-full h-full overflow-x-auto custom-scrollbar">
        <table className="min-w-full table-fixed">{children}</table>
      </div>
    </div>
  );
}

export function TableHeading({ children, customClass }: { children: JSX.Element; customClass?: string }) {
  return <thead className={`border-b ${customClass}`}>{children}</thead>;
}

export function TableBody({ children }: { children: JSX.Element | JSX.Element[] }) {
  return <tbody className="border-b">{children}</tbody>;
}

export function TableHeadingCol({
  label,
  onClick,
  component
}: {
  label: string;
  onClick?: () => void;
  component?: any;
}) {
  return (
    <th
      onClick={() => onClick && onClick()}
      className="text-sm text-left text-gray-900 font-medium px-4 py-2 whitespace-nowrap"
    >
      {component ? component : label}
    </th>
  );
}

export function TableRowItemData({
  text,
  component,
  onClick
}: {
  text?: string;
  component?: any;
  onClick?: () => void;
}) {
  return (
    <td
      onClick={() => onClick && onClick()}
      className="text-sm text-left text-gray-900 font-light px-4 py-2 whitespace-nowrap cursor-pointer overflow-ellipsis"
    >
      {component ? component : <p className="overflow-hidden overflow-ellipsis">{text}</p>}
    </td>
  );
}

export function TableRow({ children, onClick }: { children: JSX.Element | JSX.Element[]; onClick?: () => void }) {
  return <tr onClick={() => onClick && onClick()}>{children}</tr>;
}
